import React from "react";
import Pie1 from "../../../assets/images/pie1.png";
import Pie2 from "../../../assets/images/pie2.png";
import USA from "../../../assets/images/usa.png";
import Plus from "../../../assets/svgs/Plus";
import Canada from "../../../assets/images/canada.png";
import Japan from "../../../assets/images/japan.png";

function Emp({ Image, employees }) {
  return (
    <div className="flex justify-start space-x-10 items-center">
      <img src={Image} alt="" />
      <div className="w-full flex items-center">
        <div
          style={{ width: `${employees}%` }}
          className="h-1 bg-pink-500 mr-5"
        />
        <span>{employees}</span>
      </div>
    </div>
  );
}

const LeftSide = () => {
  return (
    <div>
      <p className="px-3 py-0.5 mb-2 rounded-sm bg-pink-600 inline-block text-white">
        Team
      </p>

      <div className="w-full lg:w-fit lg:flex lg:space-x-24 xl:block xl:space-x-0">
        <div className="flex space-x-4">
          <div className="p-4 shadow-xl w-full lg:w-fit bg-gray-50">
            <img src={Pie1} alt="" />
            <p className="text-2xl">35</p>
            <div className="flex items-center justify-start space-x-2">
              <div className="w-3 h-3 rounded-full bg-green-500" />
              <p className="sm:w-36 text-xs">Active Employees</p>
            </div>
          </div>
          <div className="p-4 shadow-xl w-full lg:w-fit bg-gray-50">
            <img src={Pie2} alt="" />
            <p className="text-2xl">35</p>
            <div className="flex items-center justify-start space-x-2">
              <div className="w-3 h-3 rounded-full bg-green-400" />
              <p className="sm:w-36 text-xs">Employees Onboarding</p>
            </div>
          </div>
        </div>

        <div className="">
          <p
            style={{ boxShadow: "0px 8px 8px lightblue" }}
            className="w-full text-xl my-8 px-6 inline-block py-2 rounded bg-gray-100"
          >
            Employee Country Explorer
          </p>

          <div className="flex justify-between items-center w-full">
            <div className="shadow-xl w-10/12 p-3 bg-gray-100 space-y-3">
              <Emp Image={USA} employees="55" />
              <Emp Image={Canada} employees="38" />
              <Emp Image={Japan} employees="27" />
            </div>
            <button className="w-8 h-8 flex items-center justify-center rounded-full bg-pink-500 text-white">
              <Plus />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftSide;
